import { formatNumber, withPercentSign } from "./number";

export interface FormattableCell {
  column: { source: string };
  value: number | null;
  decimals?: number;
  text?: string | null;
}

// Note: a relative variance is a percentage whatever the row's unit, so the row's decimals do not apply to it.
export const cellDecimals = (column: { source: string; decimals?: number }, rowDecimals?: number): number | undefined =>
  column.source === "variance_pct" ? (column.decimals ?? 1) : (rowDecimals ?? column.decimals);

// Note: decimals is a fixed precision, not a cap. Without a matching minimum the trailing zeros are
// dropped, so a cell asking for two places renders a whole number as "97".
export function formatCell(cell: FormattableCell): string {
  if (cell.text != null) return cell.text;
  if (cell.value == null) return "-";
  const text = formatNumber(cell.value, cell.decimals == null
    ? { maximumFractionDigits: 2 }
    : { minimumFractionDigits: cell.decimals, maximumFractionDigits: cell.decimals });
  return cell.column.source === "variance_pct" ? withPercentSign(text) : text;
}
